// eslint-disable-next-line no-shadow
enum palette {
  // primary
  blueNavy = '#0C273A',
  blue = '#2F9BD8',
  green = '#25C984',
  yellow = '#F6BB43',
  orange = '#D85D2F',
  red = '#E54A64',
  purple = '#7548F3',

  // +1 variant
  blueSlate = '#437D9D',
  blueSky = '#67C2F5',
  greenMint = '#51F0A2',
  yellowButter = '#FFD47B',
  orangeCoral = '#F48B64',
  redFlamingo = '#FD7188',
  purpleLavender = '#9E7EEF',

  // -1 variant
  blueInk = '#031725',
  blueDenim = '#104E71',
  greenPine = '#047870',
  yellowHoney = '#C9812D',
  orangeRust = '#7B2D0F',
  redCherry = '#800428',
  purpleGrape = '#451DAB',

  // utilities
  blueGrey = '#DCDCDC',
  blueWhite = '#F3F3F3',
  white = '#FFFFFF',
}

export default palette;
